import slotDefinition from "slotworks/model/slot-definition";
import symbolSubstituteSupplement from "slotworks/model/gameplay/supplements/symbol-substitute-supplement";
import isMcSymbol, { isBonusWild } from "utils/is-mc-symbol";
import graphicsManager from "slotworks/graphics/graphics-manager";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import SymbolDefinition from "slotworks/model/symbol-definition";

class SubstituteSymbols {

    public postfix = "fb_b";

    public addDarkSymbolDefinitions() {

        this.updateReelsetDefinition();

        const dimmedBonusSymbols = slotDefinition.symbolDefinitions.filter((symbol) => this.hasBonusDim(symbol));

        const darkSymbols = dimmedBonusSymbols.map((symbolDefinition) => {
            const clone = symbolDefinition.clone();
            clone.id = `${clone.id}_${this.postfix}`;
            return clone;
        });

        slotDefinition.symbolDefinitions = slotDefinition.symbolDefinitions.concat(darkSymbols);
    }

    public withDarkSymbols() {
        this.addSymbolSubstitutions();
    }

    public withRegularSymbols() {
        symbolSubstituteSupplement.replacements.clear();
    }

    public generateDimImages() {

        slotDefinition.symbolDefinitions.forEach((symbolDefinition) => {

            const isNotBaseSymbol = symbolDefinition.id.indexOf("_") >= 0;
            if (!this.hasBonusDim(symbolDefinition) || isNotBaseSymbol) {
                return;
            }

            const symbolSprite = graphicsManager.createSprite(`${symbolDefinition.id}_${this.postfix}`);
            const labelTexture = PIXI.RenderTexture.create(symbolSprite.width, symbolSprite.height);

            const renderer = canvasManager.renderer;
            renderer.render(symbolSprite, labelTexture, false);

            const textureName = `${symbolDefinition.id}_${this.postfix}`;
            graphicsManager.addTexture(textureName, labelTexture);
        });
    }

    private hasBonusDim(symbol: SymbolDefinition) {
        return !isMcSymbol(symbol.id) && !isBonusWild(symbol.id);
    }

    private addSymbolSubstitutions() {
        slotDefinition.symbolDefinitions.forEach((symbolDefinition) => {
            const symbolID = symbolDefinition.id;
            const darkSymbol = `${symbolID}_${this.postfix}`;
            if (!isMcSymbol(symbolID)) {
                symbolSubstituteSupplement.replacements.set(symbolID, darkSymbol);
            }
        });
    }

    private updateReelsetDefinition() {
        slotDefinition.reelsets.get("multireel").forEach((reel) => {
            reel.forEach((symbol, index) => {
                if (!isMcSymbol(symbol)) {
                    reel[index] = `${reel[index]}_${this.postfix}`;
                }
            });
        });
    }
}

export default new SubstituteSymbols();
